<template>
  <div class="contact-info dbox">
    <TextField2
      :id="'phone1'"
      :placeholder="$t('phone1')"
      :label="$t('phone1')"
      :value="contact.phone1"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :id="'phone2'"
      :placeholder="$t('phone2')"
      :label="$t('phone2')"
      :value="contact.phone2"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :id="'email1'"
      :placeholder="$t('email')"
      :label="$t('email')"
      :value="contact.email1"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :id="'email2'"
      :placeholder="$t('email_2')"
      :label="$t('email_2')"
      :value="contact.email2"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :id="'skype'"
      :placeholder="$t('skype')"
      :label="$t('skype')"
      :value="contact.skype"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :id="'fax1'"
      :placeholder="$t('fax')"
      :label="$t('fax')"
      :value="contact.fax1"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :id="'url1'"
      :placeholder="$t('url_1')"
      :label="$t('url_1')"
      :value="contact.url1"
      @blur="onTextFieldValueChange"
      bb="none"
    />
  </div>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";

import { EventHooks } from "@/plugins/text-field";

export default {
  components: {
    TextField,
    Dropdown,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group .dt-dropdown {
  margin: 5px 5px !important;
}
</style>
